// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"viewerjs":"0ab1a93d5350b02efca1","iframe-responsive":"9b68ea466cf88334da0c"}[chunkId] + ".css";
};